import { Box, Flex, Text } from '@chakra-ui/react';
import NavLink, { SignoutNavLink } from './NavLink';

function Navbar() {
  return (
    <Box w="130px" p="20px">
      <Flex
        direction="column"
        width="100%"
        bg="purple.500"
        h="100%"
        py={10}
        borderRadius="2xl"
        boxShadow="dark-lg"
      >
        <Text fontWeight="bold" fontSize="2xl" color="white" textAlign="center" pb={10}>
          LM
        </Text>
        <Flex direction="column" flex={1} justifyContent="space-between">
          <Box>
            <NavLink to="/" icon={['fal', 'house']} title="Home" />
            <NavLink to="clients" icon={['fal', 'users']} title="Clients" />
            <NavLink to="locations" icon={['fal', 'location-dot']} title="Locations" />
          </Box>

          <SignoutNavLink />
        </Flex>
      </Flex>
    </Box>
  );
}

export default Navbar;
